var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"repair-block"},[_c('div',{staticStyle:{"width":"100%","height":"100%"}},[_c('fm-table-new',{attrs:{"simple-filter":true,"columns":_vm.columnList,"auto-height":true,"border":"row","handler-counter":_vm.countFun,"data-list":_vm.dataList,"stripe":false,"emptyPlaceholder":"-"},on:{"counterChange":_vm.countDataChange}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }